import { useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import ChequesWorkspacePage from "./ChequesWorkspacePage";
import { useChequeRole } from "../utils/useChequeRole";
import { CHEQUE_ISSUES_SUBMODULE_SLUG } from "../utils/chequePermissionSlugs";

const CANONICAL_PATH = "/app/cheques/issues";

/**
 * Single cheque workspace at /app/cheques/issues.
 * Legacy URLs /app/cheques and /app/cheques/control render here and normalize.
 */
const ChequeIssuesWorkspacePage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const perms = useChequeRole(CHEQUE_ISSUES_SUBMODULE_SLUG);

  useEffect(() => {
    if (location.pathname !== CANONICAL_PATH) {
      navigate(CANONICAL_PATH, { replace: true });
    }
  }, [location.pathname, navigate]);

  if (perms.permissionsLoading) {
    return (
      <div className="app-screen-guard app-screen-guard--loading">
        <p>Loading access…</p>
      </div>
    );
  }

  if (!perms.canView) {
    return <Navigate to="/user-login" replace />;
  }

  return <ChequesWorkspacePage />;
};

export default ChequeIssuesWorkspacePage;
